import { render, staticRenderFns } from "./ProfileRecipe.vue?vue&type=template&id=593ec591"
import script from "./ProfileRecipe.vue?vue&type=script&lang=js"
export * from "./ProfileRecipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports